<template>
	<div>
		<div v-if="!localOpen" class="flex items-start space-x-4">
			<div :class="flexGrow ? 'flex-grow' : ''">
				<slot name="closed"></slot>
			</div>

			<ui-button
				class="-mt-2 ml-auto hover:bg-gray-100 rounded-lg p-2 text-orange-500"
				v-on:click="localOpen = true"
				type="blank"
			>
				<ui-icon name="edit-2" class="text-orange h-6 w-6" stroke-width="2" />
			</ui-button>
		</div>
		<div v-else>
			<slot name="open"></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		open: {
			type: Boolean,
			default: false,
		},
		flexGrow: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			localOpen: this.open,
		};
	},
};
</script>
